import { PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import {
    CreateLogRequestInput,
    LogRequest,
    LogRequestUserMapping,
} from "generated-interfaces/graphql";
import { put, takeEvery } from "redux-saga/effects";

import { getSdk } from "utils/network";
import {
    fetchLogRequestUserMappings,
    fetchLogRequest,
    createLogRequest,
    LOG_REQUEST_ACTIONS,
} from "../reducers/logRequestReducer";

function* fetchLogRequestUserMappingsSaga() {
    console.log("fetchLogRequestUserMappingsSaga");
    try {
        const sdk = getSdk();

        const response: {
            logRequestUserMappings: LogRequestUserMapping[];
        } = yield sdk.logRequestUserMappings();

        yield put(
            LOG_REQUEST_ACTIONS.fetchLogRequestUserMappingSuccess(
                response.logRequestUserMappings
            )
        );
    } catch (error) {
        console.log(error);
    }
}

function* getLogRequestSaga(action: PayloadAction<number>) {
    console.log("getLogRequestSaga");
    try {
        const sdk = getSdk();
        yield put(LOG_REQUEST_ACTIONS.fetchLogRequestLoading());

        const response: {
            getLogRequest: LogRequest;
        } = yield sdk.getLogRequest({
            id: action.payload,
        });

        yield put(
            LOG_REQUEST_ACTIONS.fetchLogRequestSuccess(response.getLogRequest)
        );
    } catch (error) {
        yield put(LOG_REQUEST_ACTIONS.fetchLogRequestFailed());
        console.log(error);
    }
}

function* createLogRequestSaga(action: PayloadAction<CreateLogRequestInput>) {
    console.log("createLogRequestSaga");
    try {
        const sdk = getSdk();
        yield put(LOG_REQUEST_ACTIONS.createLogRequestLoading());

        const response: {
            createLogRequest: LogRequest;
        } = yield sdk.createLogRequest({
            data: action.payload,
        });

        yield put(
            LOG_REQUEST_ACTIONS.createLogRequestSuccess(
                response.createLogRequest
            )
        );

        yield put(fetchLogRequestUserMappings());

        yield put(push(`/log/${response.createLogRequest.id}`));
    } catch (error) {
        yield put(LOG_REQUEST_ACTIONS.createLogRequestFailed());
        console.log(error);
    }
}

export default function* logRequestSaga() {
    yield takeEvery(
        fetchLogRequestUserMappings.toString(),
        fetchLogRequestUserMappingsSaga
    );
    yield takeEvery(fetchLogRequest.toString(), getLogRequestSaga);
    yield takeEvery(createLogRequest.toString(), createLogRequestSaga);
}
